<header [class.can-scroll]="applicationMenuCanScroll">
  <dx-toolbar class="header-toolbar">
    <dxi-item location="before">
      <span class="logoFrame">
        <a [href]="logoRoute" title="Navigate to Huron Consulting Group Home">
          <img src="assets/huron-logo.svg" alt="Huron Consulting Group Logo" class="logo" />
        </a>
      </span>
    </dxi-item>
    <dxi-item
      location="after"
      locateInMenu="never">
      <div *dxTemplate="let data of 'item'" class="header-content">
        <div class="user-info">
          <span class="brandingName">{{ user?.brandingName }} </span>
          <span class="divider">|</span>
          <span class="name">Hello, {{user?.firstName}}</span>
        </div>
        <huron-notifications *ngIf="showNotifications" [user]="user"></huron-notifications>
        <dx-button [disabled]="!user || !user.userId"
          class="user-button authorization"
          stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <huron-user-menu [user]="user" menuMode="context"></huron-user-menu>
          </div>
        </dx-button>
      </div>
    </dxi-item>
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="after"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
    </dxi-item>
  </dx-toolbar>

  <dx-toolbar class="header-toolbar sub-header" id="applicationHeader" (onContentReady)="onContentReadyHeader()" >    
    <dxi-item location="before" *ngIf="activeApplications" class="applications">
        <a *ngFor="let app of activeApplications"
          (click)="openApplicationLink(app)"
          [class]="'application-link ' + app.abbreviation.toLocaleLowerCase()"
          [class.selected]="app.abbreviation.toLocaleLowerCase() == applicationAbbreviation"
          >
          {{app.name}}
        </a>
    </dxi-item>
  </dx-toolbar>
  
  <button class="scroll-button left" (click)="scrollLeft()">
    <span class="material-symbols-outlined">
      navigate_before
    </span>
  </button>
  <button class="scroll-button right" (click)="scrollRight()">
    <span class="material-symbols-outlined">
      navigate_next
      </span>
  </button>
</header>
